import React from 'react';

const CookiePolicyPage = ({ title }) => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-8">{title}</h1>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">쿠키 정책</h2>
        <p className="mb-4">
          소프트캣(이하 "회사")은 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 
          다음과 같이 쿠키 정책을 수립하여 공개합니다.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">1. 쿠키란 무엇인가요?</h2>
        <p className="mb-4">
          쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 작은 텍스트 파일로, 
          이용자의 컴퓨터 하드디스크에 저장됩니다. 이후 이용자가 웹사이트에 방문할 경우 웹사이트 서버는 
          이용자의 하드 디스크에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하기 위해 이용됩니다.
        </p>
        <p className="mb-4">
          쿠키는 개인을 식별하는 정보를 자동적으로 수집하지 않으며, 이용자는 언제든지 이러한 쿠키의 저장을 
          거부하거나 삭제할 수 있습니다.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">2. 회사가 사용하는 쿠키의 종류</h2>
        <div className="mb-4">
          <h3 className="text-xl font-medium mb-2">2.1 필수 쿠키</h3>
          <p className="mb-2">
            웹사이트의 기본적인 기능을 활성화하기 위한 쿠키로, 이 쿠키가 없으면 웹사이트가 제대로 작동하지 않습니다.
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>세션 관리 및 보안 유지</li>
            <li>로그인 상태 유지</li>
            <li>장바구니 기능 제공</li>
          </ul>
        </div>
        
        <div className="mb-4">
          <h3 className="text-xl font-medium mb-2">2.2 기능 쿠키</h3>
          <p className="mb-2">
            웹사이트에서 이용자가 방문한 페이지나 선택한 옵션 등을 기억하여 향상된 기능과 개인 맞춤 서비스를 제공합니다.
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>언어 설정 저장</li>
            <li>폰트 크기 및 디자인 설정</li>
            <li>최근 본 상품 정보</li>
          </ul>
        </div>
        
        <div className="mb-4">
          <h3 className="text-xl font-medium mb-2">2.3 분석 쿠키</h3>
          <p className="mb-2">
            웹사이트 방문자 수, 페이지 뷰, 트래픽 소스 등을 측정하여 웹사이트 성능을 분석하고 개선하는 데 사용됩니다.
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Google Analytics</li>
            <li>네이버 애널리틱스 (네이버 검색·블로그·카페 유입 경로 분석)</li>
            <li>방문자 행동 패턴 분석</li>
            <li>웹사이트 사용성 개선</li>
          </ul>
        </div>
        
        <div className="mb-4">
          <h3 className="text-xl font-medium mb-2">2.4 마케팅 쿠키</h3>
          <p className="mb-2">
            이용자의 웹사이트 방문 기록에 따라 관심사에 맞는 광고를 표시하는 데 사용됩니다.
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>맞춤형 광고 제공</li>
            <li>리마케팅 캠페인</li>
            <li>광고 효과 측정</li>
            <li>Meta 픽셀 (페이스북·인스타그램 광고 성과 측정 및 리마케팅)</li>
          </ul>
          <p className="mb-2">
            광고를 집행하는 기간에만 사용하며, 집행하지 않을 때는 해당 쿠키를
            수집하지 않습니다. 브라우저 설정에서 쿠키를 차단하면 수집되지 않습니다.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">3. 쿠키 관리 방법</h2>
        <p className="mb-4">
          이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 웹 브라우저에서 옵션을 설정함으로써 
          모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
        </p>
        
        <div className="mb-4">
          <h3 className="text-xl font-medium mb-2">주요 브라우저 쿠키 설정 방법</h3>
          <ul className="list-disc pl-6 mb-4">
            <li><strong>Chrome</strong>: 설정 &gt; 개인정보 및 보안 &gt; 쿠키 및 기타 사이트 데이터</li>
            <li><strong>Edge</strong>: 설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트 데이터 관리 및 삭제</li>
            <li><strong>Firefox</strong>: 옵션 &gt; 개인 정보 및 보안 &gt; 쿠키 및 사이트 데이터</li>
            <li><strong>Safari</strong>: 환경설정 &gt; 개인정보 보호 &gt; 쿠키 및 웹 사이트 데이터</li>
          </ul>
          <p className="mb-2">
            단, 쿠키의 저장을 거부할 경우 로그인이 필요한 서비스 등 일부 서비스 이용에 어려움이 있을 수 있습니다.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">4. 쿠키 정책 변경</h2>
        <p className="mb-4">
          회사는 법률이나 서비스의 변경사항을 반영하기 위하여 본 쿠키 정책을 변경할 수 있습니다. 
          쿠키 정책이 변경되는 경우 변경 사항은 웹사이트를 통해 공지됩니다.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">5. 문의처</h2>
        <p className="mb-4">
          쿠키 정책에 대해 궁금한 점이 있으시거나 의견이 있으신 경우 아래의 연락처로 문의해 주시기 바랍니다.
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>이메일: oracle7579@gmail.com</li>
          <li>전화번호: 010-4414-7579</li>
        </ul>
      </section>

      <div className="text-right text-gray-600">
        <p>최종 업데이트: 2025년 7월 15일</p>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
